<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-02-18',
        major: [],
        excepts: [],
        items: [

          // [NOTE] だいあフェス大会参加賞
          // ================================================================================

          item({
            collection  : 'だいあフェス大会参加賞',
            id          : 'DF-03',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあワンピ',
            imgUrl      : '/images/items/DF-03.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 2, usual: 4 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス大会参加賞',
            id          : 'DF-01',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあシューズ',
            imgUrl      : '/images/items/DF-01.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 2, usual: 4 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス大会参加賞',
            id          : 'DF-02',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあヘアアクセ',
            imgUrl      : '/images/items/DF-02.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 2, usual: 5 },
            numReleased : { kira: 0, usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス大会参加賞',
          }),


          // [NOTE] だいあフェス抽選参加賞
          // ================================================================================

          item({
            collection  : 'だいあフェス抽選参加賞',
            id          : 'P-087',
            rare        : 'JR',
            name        : 'ときめきのピンクジュエルドレス',
            imgUrl      : '/images/items/P-087.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス抽選参加賞',
            id          : 'P-106',
            rare        : 'JR',
            name        : 'ちしきのパープルジュエルドレス',
            imgUrl      : '/images/items/P-106.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス抽選参加賞',
            id          : 'P-117',
            rare        : 'JR',
            name        : 'しあわせのゴールドジュエルドレス',
            imgUrl      : '/images/items/P-117.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあフェス抽選参加賞',
          }),



          // [NOTE] プリズムストーン 2019年冬ノベルティプリチケ
          // ================================================================================

          item({
            collection  : 'PS2019Winter',
            id          : 'P-197',
            rare        : 'SR',
            name        : 'レインボーライブパープルトップス',
            imgUrl      : '//via.placeholder.com/100/fff/D79FFF/?text=P-197',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2019Winter',
            id          : 'P-198',
            rare        : 'SR',
            name        : 'レインボーライブパープルスカート',
            imgUrl      : '//via.placeholder.com/100/fff/D79FFF/?text=P-198',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DC',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2019Winter',
            id          : 'P-199',
            rare        : 'SR',
            name        : 'レインボーライブパープルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/D79FFF/?text=P-199',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'DC',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PS2019Winter',
            id          : 'P-200',
            rare        : 'SR',
            name        : 'レインボーライブパープルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/D79FFF/?text=P-200',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DC',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] スタンプラリー（広島・仙台）
          // ================================================================================

          item({
            collection  : 'StampRallyHS',
            id          : 'P-140',
            rare        : 'SR',
            name        : 'ティーパーティーブルベリートップス',
            imgUrl      : '/images/items/P-140.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'StampRallyHS',
            id          : 'P-141',
            rare        : 'SR',
            name        : 'ティーパーティーブルベリースカート',
            imgUrl      : '/images/items/P-141.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'StampRallyHS',
            id          : 'P-142',
            rare        : 'SR',
            name        : 'ティーパーティーブルベリーシューズ',
            imgUrl      : '/images/items/P-142.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'StampRallyHS',
            id          : 'P-143',
            rare        : 'SR',
            name        : 'ティーパーティーブルベリーヘアアクセ',
            imgUrl      : '/images/items/P-143.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] フェニックス杯参加賞
          // ================================================================================

          item({
            collection  : 'PhoenixCup',
            id          : 'P-NC-001',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドワンピ',
            imgUrl      : '/images/items/P-NC-001.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PhoenixCup',
            id          : 'P-NC-001-S',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドシューズ',
            imgUrl      : '/images/items/P-NC-001-S.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            aggregation : 'P-NC-001',
          }),
          item({
            collection  : 'PhoenixCup',
            id          : 'P-NC-001-H',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドヘアアクセ',
            imgUrl      : '/images/items/P-NC-001-H.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            aggregation : 'P-NC-001',
          }),
          item({
            collection  : 'PhoenixCup',
            rare        : 'R',
          }),


          // [NOTE] シルバークラス認定会
          // ================================================================================

          item({
            collection  : 'SilverRecognition',
            id          : 'P-039',
            rare        : 'SR',
            name        : 'スターダストピンクグラデワンピ',
            imgUrl      : '/images/items/P-039.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SilverRecognition',
            rare        : 'SR',
          }),
          item({
            collection  : 'SilverRecognition',
            rare        : 'SR',
          }),
          item({
            collection  : 'SilverRecognition',
            rare        : 'SR',
          }),


          // [NOTE] ゴールドクラス認定会
          // ================================================================================

          item({
            collection  : 'GoldRecognition',
            id          : 'P-103',
            rare        : 'KR',
            name        : 'スイートハニーゴールドキラッとワンピ',
            imgUrl      : '/images/items/P-103.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'SH',
            type        : 'LO',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GoldRecognition',
            id          : 'P-104',
            rare        : 'KR',
            name        : 'スイートハニーゴールドキラッとシューズ',
            imgUrl      : '/images/items/P-104.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GoldRecognition',
            id          : 'P-105',
            rare        : 'KR',
            name        : 'スイートハニーゴールドキラッとヘアアクセ',
            imgUrl      : '/images/items/P-105.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GoldRecognition',
            rare        : 'KR',
          }),


          // [NOTE] プラチナクラス認定会
          // ================================================================================

          item({
            collection  : 'PlatinumRecognition',
            id          : 'P-NC-002',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとワンピ',
            imgUrl      : '/images/items/P-NC-002-O.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 1570,
            numOwned    : { nico: 1 },
            numReleased : { nico: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PlatinumRecognition',
            id          : 'P-NC-002-S',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとシューズ',
            imgUrl      : '/images/items/P-NC-002-S.png',
            kind        : 'シューズ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            aggregation : 'P-NC-002',
          }),
          item({
            collection  : 'PlatinumRecognition',
            id          : 'P-NC-002-H',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとヘアアクセ',
            imgUrl      : '/images/items/P-NC-002-H.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            aggregation : 'P-NC-002',
          }),
          item({
            collection  : 'PlatinumRecognition',
            rare        : 'KR',
          }),


          // [NOTE] ジュエル3弾スペシャルキラチケキャンペーン
          // ================================================================================

          item({
            collection  : 'J03SpKiraTicke',
            id          : 'P-107',
            rare        : 'HR',
            name        : 'シンデレラプリンスオレンジワンピ',
            imgUrl      : '/images/items/P-107.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J03SpKiraTicke',
            id          : 'P-109',
            rare        : 'HR',
            name        : 'シンデレラプリンスオレンジヘアアクセ',
            imgUrl      : '/images/items/P-109.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J03SpKiraTicke',
            rare        : 'HR',
          }),
          item({
            collection  : 'J03SpKiraTicke',
            rare        : 'HR',
          }),


          // [NOTE] ジュエル4弾スペシャルキラチケキャンペーン
          // ================================================================================

          item({
            collection  : 'J04SpKiraTicke',
            id          : 'P-122',
            rare        : 'HR',
            name        : 'おとのさまもえぎワンピ',
            imgUrl      : '/images/items/P-122.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J04SpKiraTicke',
            id          : 'P-124',
            rare        : 'HR',
            name        : 'おとのさまもえぎヘアアクセ',
            imgUrl      : '/images/items/P-124.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J04SpKiraTicke',
            rare        : 'HR',
          }),
          item({
            collection  : 'J04SpKiraTicke',
            rare        : 'HR',
          }),


          // [NOTE] ジュエル5弾スペシャルキラニコチケキャンペーン
          // ================================================================================

          item({
            collection  : 'J05SpKiraNico',
            id          : 'P-NC-003',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあピンクワンピ',
            imgUrl      : '/images/items/P-NC-003-O.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 2000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J05SpKiraNico',
            id          : 'P-NC-003-S',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあピンクシューズ',
            imgUrl      : '/images/items/P-NC-003-S.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            aggregation : 'P-NC-003',
          }),
          item({
            collection  : 'J05SpKiraNico',
            id          : 'P-NC-003-H',
            rare        : 'PR',
            name        : 'ミルキーレインボーだいあピンクヘアアクセ',
            imgUrl      : '/images/items/P-NC-003-H.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            aggregation : 'P-NC-003',
          }),
          item({
            collection  : 'J05SpKiraNico',
            rare        : 'PR',
          }),



          // [NOTE] ジュエル6弾スペシャルキラニコチケキャンペーン
          // ================================================================================

          item({
            collection  : 'J06SpKiraNico',
            id          : 'P-NC-005',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルワンピ',
            imgUrl      : '/images/items/P-NC-005-O.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 3900,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'J06SpKiraNico',
            id          : 'P-NC-005-S',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルシューズ',
            imgUrl      : '/images/items/P-NC-005-S.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 0,
            aggregation : 'P-NC-005',
          }),
          item({
            collection  : 'J06SpKiraNico',
            id          : 'P-NC-005-H',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルヘアアクセ',
            imgUrl      : '/images/items/P-NC-005-H.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 0,
            aggregation : 'P-NC-005',
          }),
          item({
            collection  : 'J06SpKiraNico',
            rare        : 'JR',
          }),


          // [NOTE] クーリッシュグレーコーデスペシャルキャンペーン
          // ================================================================================

          item({
            collection  : 'CGCSpecial',
            id          : 'P-180',
            rare        : 'SR',
            name        : 'クーリッシュブルゾン＆グレーロンT',
            imgUrl      : '/images/items/P-180.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : 'DS',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CGCSpecial',
            id          : 'P-181',
            rare        : 'SR',
            name        : 'クーリッシュパープルスニーカー',
            imgUrl      : '/images/items/P-181.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CGCSpecial',
            id          : 'P-182',
            rare        : 'SR',
            name        : 'クーリッシュパープルヘアアクセ',
            imgUrl      : '/images/items/P-182.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CGCSpecial',
            rare        : 'SR',
          }),


          // [NOTE] あーつあつ！もーりもりフェア
          // ================================================================================

          item({
            collection  : 'ArtsMollyFare',
            id          : 'P-125',
            rare        : 'R',
            name        : 'ゆうびんやさんおひさまワンピ',
            imgUrl      : '/images/items/P-125.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ArtsMollyFare',
            id          : 'P-126',
            rare        : 'R',
            name        : 'ゆうびんやさんおひさまシューズ',
            imgUrl      : '/images/items/P-126.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ArtsMollyFare',
            id          : 'P-127',
            rare        : 'R',
            name        : 'ゆうびんやさんおひさまヘアアクセ',
            imgUrl      : '/images/items/P-127.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ArtsMollyFare',
            rare        : 'R',
          }),


          // [NOTE] モーリーファンタジーダブルゲットキャンペーン！
          // ================================================================================

          item({
            collection  : 'MollyWGet',
            id          : 'MF-29',
            rare        : 'SR',
            name        : 'ファンタジークルッとレッドワンピ',
            imgUrl      : '/images/items/MF-29.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-30',
            rare        : 'SR',
            name        : 'ファンタジークルッとレッドシューズ',
            imgUrl      : '/images/items/MF-30.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-31',
            rare        : 'SR',
            name        : 'ファンタジークルッとレッドヘアアクセ',
            imgUrl      : '/images/items/MF-31.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            rare        : 'SR',
          }),


          item({
            collection  : 'MollyWGet',
            id          : 'MF-32',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアパープルトップス',
            imgUrl      : '/images/items/MF-32.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-33',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアパープルスカート',
            imgUrl      : '/images/items/MF-33.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-34',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアパープルシューズ',
            imgUrl      : '/images/items/MF-34.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-35',
            rare        : 'PR',
            name        : 'ホーンテッドヴァンパイアパープルヘアアクセ',
            imgUrl      : '/images/items/MF-35.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'MollyWGet',
            id          : 'MF-36',
            rare        : 'SR',
            name        : 'ファンタジークルッとパープルワンピ',
            imgUrl      : '/images/items/MF-36.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-37',
            rare        : 'SR',
            name        : 'ファンタジークルッとパープルシューズ',
            imgUrl      : '/images/items/MF-37.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-38',
            rare        : 'SR',
            name        : 'ファンタジークルッとパープルヘアアクセ',
            imgUrl      : '/images/items/MF-38.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            rare        : 'SR',
          }),


          item({
            collection  : 'MollyWGet',
            id          : 'MF-39',
            rare        : 'PR',
            name        : 'フルスイングスターグリーントップス',
            imgUrl      : '/images/items/MF-39.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-40',
            rare        : 'PR',
            name        : 'フルスイングスターグリーンパンツ',
            imgUrl      : '/images/items/MF-40.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-41',
            rare        : 'PR',
            name        : 'フルスイングスターグリーンシューズ',
            imgUrl      : '/images/items/MF-41.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'MollyWGet',
            id          : 'MF-42',
            rare        : 'PR',
            name        : 'フルスイングスターグリーンヘアアクセ',
            imgUrl      : '/images/items/MF-42.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] ちゃおサマーツアー＆フェスティバル2019
          // ================================================================================

          item({
            collection  : 'ChaoFes2019',
            id          : 'P-110',
            rare        : 'R',
            name        : 'パステルチューリップグリーンワンピ',
            imgUrl      : '/images/items/P-110.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2019',
            id          : 'P-111',
            rare        : 'R',
            name        : 'パステルチューリップグリーンシューズ',
            imgUrl      : '/images/items/P-111.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2019',
            id          : 'P-112',
            rare        : 'R',
            name        : 'パステルチューリップグリーンヘアアクセ',
            imgUrl      : '/images/items/P-112.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2019',
            rare        : 'R',
          }),


          // [NOTE] 東京おもちゃショー2019
          // ================================================================================

          item({
            collection  : 'TokyoToyShow2019',
            id          : 'P-088',
            rare        : 'R',
            name        : 'レッド×イエローチェックワンピ',
            imgUrl      : '/images/items/P-088.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'TokyoToyShow2019',
            id          : 'P-089',
            rare        : 'R',
            name        : 'レッド×イエローチェックシューズ',
            imgUrl      : '/images/items/P-089.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'TokyoToyShow2019',
            id          : 'P-090',
            rare        : 'R',
            name        : 'レッド×イエローチェックヘアアクセ',
            imgUrl      : '/images/items/P-090.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'TokyoToyShow2019',
            rare        : 'R',
          }),


          // [NOTE]
          // ================================================================================


        ]
      }
    },

    methods: {
      collection (collection = '') {
        return _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,3]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="だいあフェス大会参加賞" color="#ffa1bc" :items="collection('だいあフェス大会参加賞')" />
      <ItemList title="だいあフェス抽選参加賞" color="#44cd1f" :items="collection('だいあフェス抽選参加賞')" />
      <ItemList title="フェニックス杯参加賞" color="#feab0d" :items="collection('PhoenixCup')" />
    </template>

    <template #col2>
      <ItemList title="シルバークラス認定会" color="#00c7da" :items="collection('SilverRecognition')" />
      <ItemList title="ゴールドクラス認定会" color="#ff5d91" :items="collection('GoldRecognition')" />
      <ItemList title="プラチナクラス認定会" color="#ff5d91" :items="collection('PlatinumRecognition')" />
    </template>

    <template #col3>
      <ItemList title="ジュエル3弾|スペシャルキラチケ" color="#ff5d91" :items="collection('J03SpKiraTicke')" />
      <ItemList title="ジュエル4弾|スペシャルキラチケ" color="#ff5d91" :items="collection('J04SpKiraTicke')" />
      <ItemList title="ジュエル5弾|スペシャルキラニコチケ" color="#ffa1bc" :items="collection('J05SpKiraNico')" />
      <ItemList title="ジュエル6弾|スペシャルキラニコチケ" color="#44cd1f" :items="collection('J06SpKiraNico')" />
    </template>

    <template #col4>
      <ItemList title="東京おもちゃショー2019" color="#feab0d" :items="collection('TokyoToyShow2019')" />
      <ItemList title="ちゃおフェス2019" color="#feab0d" :items="collection('ChaoFes2019')" />
      <ItemList title="クーリッシュグレーコーデ|スペシャルキャンペーン" color="#feab0d" :items="collection('CGCSpecial')" />
      <ItemList title="スタンプラリー（広島・仙台）" color="#00c7da" :items="collection('StampRallyHS')" />
      <ItemList title="プリズムストーン2019年冬|ノベルティプリチケ" color="#00c7da" :items="collection('PS2019Winter')" />
    </template>

    <template #col5>
      <ItemList title="あーつあつ！もーりもりフェア" color="#feab0d" :items="collection('ArtsMollyFare')" />
      <ItemList title="モーリーファンタジー|ダブルゲットキャンペーン！" color="#55b272" :items="collection('MollyWGet')" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    left: 0;
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
